import { useRouter } from "next/router";
import React, { useState, useEffect, useRef, useCallback } from "react";

import SearchBox from "./SearchBox";

const SearchContainer: React.FC = () => {
  const router = useRouter();
  const [focus, setFocus] = useState(false);
  const isFirstRun = useRef(true);
  const scrollY = useRef<number>(0);

  const scrollListener = useCallback(() => {
    if (focus) return;
    scrollY.current = window.scrollY;
  }, [focus]);

  const keydownListener = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Escape" && focus) {
        setFocus(false);
      }
    },
    [focus]
  );

  useEffect(() => {
    window.addEventListener("keydown", keydownListener);
    window.addEventListener("scroll", scrollListener);

    return () => {
      window.removeEventListener("keydown", keydownListener);
      window.removeEventListener("scroll", scrollListener);
    };
  });

  const unfocus = useCallback(() => setFocus(false), []);

  useEffect(() => {
    router.events.on("routeChangeStart", unfocus);

    return () => {
      router.events.off("routeChangeStart", unfocus);
    };
  }, [router, unfocus]);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }

    const { body } = document;

    if (focus) {
      body.style.position = "fixed";
      body.style.top = `-${scrollY.current}px`;
    } else {
      body.style.position = "";
      body.style.top = "";
      window.scrollTo({ top: scrollY.current });
    }
  }, [focus]);

  useEffect(() => {
    const triggerListener = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key === "k") {
        event.preventDefault();
        setFocus(!focus);
      }
    };

    window.addEventListener("keydown", triggerListener);
    return () => {
      window.removeEventListener("keydown", triggerListener);
    };
  });

  return <SearchBox focus={focus} handleClose={() => setFocus(false)} />;
};

export default SearchContainer;
